import React from 'react'
import { Container } from 'react-bootstrap'
import './ManagedAtEnterpriseLevelInfo.scss'

import ManageAtEnterpriseLevelIcon from '../../assets/images/manage-at-enterprise-level-icon.svg?url'

interface ManagedAtEnterpriseLevelInfoProps {
  resourceName: string
}

export const ManagedAtEnterpriseLevelInfo: React.FC<ManagedAtEnterpriseLevelInfoProps> = ({ resourceName }) => {
  return (
    <Container className='d-flex align-items-center flex-column gap-3'>
      <div className='d-flex justify-content-center'>
        <img src={ManageAtEnterpriseLevelIcon} alt='Manage at enterprise' />
      </div>
      <div className='managed-at-enterprise-level-info__text-block gap-3'>
        <div className='managed-at-enterprise-level-info__text-block--inner gap-1'>
          <div className='managed-at-enterprise-level-info-primary-text'>{resourceName} are managed at the enterprise level</div>
          <div className='managed-at-enterprise-level-info-secondary-text'>
            Your enterprise admin controls which apps are available for this account. Contact them for more details.
          </div>
        </div>
      </div>
    </Container>
  )
}
